// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_mag","cls2":"SingularMentionCitationModal-cls2_vQI SingularMentionCitationModal-cls1_mag"};